import { useLocation } from "react-router";
import { motion } from "framer-motion";
import type { ReactNode } from "react";

/**
 * Cross-fade suave entre páginas — apenas opacidade (sem deslocação),
 * para a página inteira aparecer como um só bloco, sem "saltos".
 * A `key` no pathname reanima o conteúdo a cada navegação.
 */
export function TransicaoPagina({ children }: { children: ReactNode }) {
  const pathname = useLocation().pathname;

  return (
    <motion.div
      key={pathname}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}
